import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UnfocusElementService {

    constructor() { }

    unfocus(event) {
        event.preventDefault();
        event.stopPropagation();
        var path = event.path || (event.composedPath && event.composedPath());
        if (path) {
            for (let element of path) {
                if (element.tagName == 'BUTTON') {
                    element.blur();
                    break;
                }
            }
        } else {
            event.target.blur();
        }
    }
}